import mock from "@/fake-db/mock.js"

const data = {
  salesLine: {
    series: [{
        name: "Subscribers",
        data: [140, 180, 150, 205, 160, 295, 125]
    }],
  },
}
mock.onGet("/api/card/card-analytics/sales/line").reply(() => {
  return [200, data.salesLine];
});

